import { render, staticRenderFns } from "./vehicle.vue?vue&type=template&id=35a22a36"
import script from "./vehicle.vue?vue&type=script&lang=js"
export * from "./vehicle.vue?vue&type=script&lang=js"
import style0 from "./vehicle.vue?vue&type=style&index=0&id=35a22a36&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports